export const ELEARNIO_ACTIVITIES = {
  LABEL: 'elearnio.label',
};
